import { put, take } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import {
  SET_PARAM_CONTAINER,
  SET_PARAM_LANGUAGE,
  SET_PARAM_BASE_URL,
  SET_PARAM_BRAND,
  SET_PARAM_CHANNEL,
} from '@corefront/redux-aba';
import { destroyApp } from '../../actions/app/initialization';

const CRITICAL_EVENTS = [
  SET_PARAM_CONTAINER,
  SET_PARAM_LANGUAGE,
  SET_PARAM_BASE_URL,
  SET_PARAM_BRAND,
  SET_PARAM_CHANNEL,
];

export function* handleABAErrors() {
  while (true) {
    const action = yield take();
    if (action?.payload?.error) {
      try {
        Sentry.captureException(
          JSON.stringify({ error: 'aba request is absent', action })
        );
      } catch (e) {
        console.warn(e);
        Sentry.captureException('aba request is absent');
      }
      if (CRITICAL_EVENTS.includes(action.type)) {
        yield put(destroyApp());
      }
    }
  }
}
